var _excluded = ["children", "disabled", "error", "isAssertiveError", "label", "marginBottom", "marginLeft", "marginRight", "marginTop", "name", "optional", "supportiveText", "tooltip"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import LabeledField from "../LabeledField";
var RadioButtonGroup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    error = _ref.error,
    isAssertiveError = _ref.isAssertiveError,
    label = _ref.label,
    marginBottom = _ref.marginBottom,
    marginLeft = _ref.marginLeft,
    marginRight = _ref.marginRight,
    marginTop = _ref.marginTop,
    name = _ref.name,
    _ref$optional = _ref.optional,
    optional = _ref$optional === void 0 ? false : _ref$optional,
    supportiveText = _ref.supportiveText,
    tooltip = _ref.tooltip,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(LabeledField, _extends({}, rest, {
    as: "fieldset",
    disabled: disabled,
    error: error,
    isAssertiveError: isAssertiveError,
    label: label,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginTop: marginTop,
    name: name,
    optional: optional,
    ref: ref,
    supportiveText: supportiveText,
    tooltip: tooltip
  }), children);
});
RadioButtonGroup.displayName = 'RadioButtonGroup';
export default RadioButtonGroup;